import { render, staticRenderFns } from "./CookiesModal.vue?vue&type=template&id=3f1cb924&scoped=true&"
import script from "./CookiesModal.vue?vue&type=script&lang=js&"
export * from "./CookiesModal.vue?vue&type=script&lang=js&"
import style0 from "./CookiesModal.vue?vue&type=style&index=0&id=3f1cb924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1cb924",
  null
  
)

export default component.exports